module.exports = __webpack_public_path__ + "img/SKPZ_Android.1cfee609.png";